import {observable} from 'mobx';
import {BaseDomainDataSource} from "../../../infrastructure/models/base-domain-data-source";
import {NewsResponseApiModel} from "./news.response-api-model";
import {NewsDomainModel} from "./news.domain-model";

export class NewsDataSource extends BaseDomainDataSource {
  apiModel: NewsResponseApiModel;
  @observable news: Array<NewsDomainModel>;

  constructor(apiModel: NewsResponseApiModel, news: Array<NewsDomainModel>) {
    super(apiModel, apiModel.request);

    this.news = news;
  }

  update(model: NewsDataSource) {
    super.update(model);

    this.news = model?.news;
  }
}
